import { useState, useEffect, useCallback } from 'react'
import Search from "./components/Search"
import ReviewInfo from "./components/ReviewInfo"
import ReactPaginate from 'react-paginate';
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { AiFillStar } from "react-icons/ai"

function App() {

  let [reviewList, setreviewList] = useState([]);

    const [offsetText, setOffsetText] = useState("");





  const fetchData = useCallback(() => {

    const url = process.env.NODE_ENV === "development" ? '/api/get-reviews.php' : 'https://www.kars4kids.org/api/get-reviews.php';


    trackPromise(
    fetch(url)
      .then(response => response.json())
      .then(data => {
        setreviewList(data)
      
    }));


  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData]);





  return (
      <>
          <div className="container">
              <div className="col-xs-12 text-center">
                  <LoadingIndicator length={reviewList.length} offsetText={offsetText} />
              </div>
          </div>


          <div className="container">
              <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">

                  <div className="card-columns">

                      <PaginatedItems itemsPerPage={1000} filterArray={reviewList} offsetText={offsetText} setOffsetText={setOffsetText}/>
                  </div>
                  </div>
                  </div>
              </>
              );
              }

const LoadingIndicator = props => {
    const { promiseInProgress } = usePromiseTracker();

    return (
        promiseInProgress ? (
            <div className="blinking"
                 style={{
                     width: "100%",
                     height: "100px", // Added "px" unit
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center"
                 }}
            >
                <AiFillStar/>
                <AiFillStar/> <AiFillStar/>
                <AiFillStar/> Loading...
            </div>
        ) : (
            <p id="stats" className="reviewShow">Showing {props.offsetText} {props.length.toLocaleString()} reviews</p>
        )
    );
}

function PaginatedItems({itemsPerPage, filterArray, offsetText, setOffsetText}) {


    const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
   const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    // Fetch items from another resources.
     const endOffset = itemOffset + itemsPerPage;
     var itemOffsetText = itemOffset + 1;
      setOffsetText( `${itemOffsetText.toLocaleString()} to ${endOffset.toLocaleString()} of` ) ;

    setCurrentItems(filterArray.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(filterArray.length / itemsPerPage));
  }, [itemOffset, itemsPerPage,filterArray]);




  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filterArray.length;
     setItemOffset(newOffset);
    document.getElementById('stats').scrollIntoView();
  };



var arrayToloop = (currentItems ? currentItems:filterArray );
  return (
    <>
      {arrayToloop


          .map((review, index) => (
            <ReviewInfo key={index}
              review={review}
              currentItems={currentItems} 
             />
          ))
        }
        
        <div className="row">
          <div className="col-md-12 " style={{ textAlign:`center` }}>
<nav aria-label="Page navigation">
      <ReactPaginate
      containerClassName ="pagination"
      activeLinkClassName="active"
        breakLabel="..."
        nextLabel=">>"
        onPageChange={handlePageClick}
   
        marginPagesDisplayed={0}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        previousLabel="<<"
        renderOnZeroPageCount={null}
      />
      </nav>
      </div>
     
                    
      </div>
    </>
  );
}


export default App;

